exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-popover.pop-lock-fil{background:#313344;border-color:#313344}.el-popover.pop-lock-fil .popper__arrow,.el-popover.pop-lock-fil .popper__arrow::after{border-bottom-color:#313344 !important}.el-popover.pop-lock-fil .pop-text{padding-top:0;border:none}.el-popover.pop-lock-fil .pop-text h3{font-size:16px;color:#FFFFFF;margin:5px 0}.el-popover.pop-lock-fil .pop-text p{font-size:18px;font-weight:bold;color:#FFE5A8;margin:0}\n", ""]);

// exports
